import PurchaseModalController from 'utils/purchase_modal/purchase_modal_component/purchase-modal-controller';
import Cookies from 'js-cookie';
import {
  sendTrackingEvent,
  trackCompleteEvent,
} from 'components/analytics/conversions/tracking';
import {
  UPGRADE_POPUP_TRIGGERED,
  UPGRADE_POPUP_CLICK,
  UPGRADE_POPUP_ERROR,
  UPGRADE_POPUP_REFUND_ERROR,
  UPGRADE_POPUP_COMPLETE,
} from 'components/analytics/conversions/constants/actions';

type ModalContext = 'triggered' | 'click'

type RefundData = {
  'credits_not_refunded':number
  'credits_refunded':number
  'refund_fully_successful':boolean
  tax:number
  'total_not_refunded':number
  'total_refunded':number
  'transaction_id':string
}
export default class UpgradeModalController extends PurchaseModalController {
  declare readonly element: HTMLElement;

  declare readonly contextValue:ModalContext;

  connect() {
    const nonInteraction = this.contextValue === 'triggered';

    sendTrackingEvent({
      element: this.element,
      data: {
        action: this.eventAction,
        category: this.eventCategory,
        non_interaction: nonInteraction,
      },
    });

    super.connect();
  }

  submitPurchase = (event) => {
    if (this.requiresCheckoutValue) {
      event.preventDefault();
      const planCheckoutTarget = JSON.parse(this.selectedPlanValue).remote_id;

      window.location.href = `${this.checkoutUrlValue}/${planCheckoutTarget}?credit_refund_upgrade=true`;
    } else {
      super.submitPurchase();
    }
  }

  purchaseSuccess = (event) => {
    super.processPurchase({ event, callback: this.checkForCreditsRefundSuccess });
  }

  checkForCreditsRefundSuccess = (refundData:RefundData) => {
    const { refund_fully_successful: refundFullySuccessful } = refundData;

    if (!refundFullySuccessful) {
      Cookies.set('credit_refund_error', JSON.stringify(refundData));

      this.sendRefundErrorEvent();
    }
  }

  sendPurchaseEvents = () => {
    trackCompleteEvent({
      action: UPGRADE_POPUP_COMPLETE,
      category: this.eventCategory,
    });
  }

  sendErrorEvents = ({ errorLabels }) => {
    sendTrackingEvent({
      element: this.element,
      data: {
        action: UPGRADE_POPUP_ERROR,
        label: errorLabels,
        category: this.eventCategory,
      },
    });
  }

  sendRefundErrorEvent = () => {
    sendTrackingEvent({
      element: this.element,
      data: {
        action: UPGRADE_POPUP_REFUND_ERROR,
        category: this.eventCategory,
      },
    });
  }

  get eventAction() {
    return this.contextValue === 'triggered' ? UPGRADE_POPUP_TRIGGERED : UPGRADE_POPUP_CLICK;
  }

  get eventCategory() {
    return this.contextValue === 'triggered' ? 'Trigger-Upgrade_Popup' : 'Trigger-Upgrade_Banner';
  }
}
